// src/features/policies/hooks/usePolicies.js

import { useCallback, useEffect, useState } from "react";
import { listPolicies } from "../api/policyApi";

export default function usePolicies(
  apiKey,
  tenantId,
  page,
  pageSize,
  search
) {
  const [policies, setPolicies] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const fetchPolicies = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!apiKey && !tenantId && !token) {
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await listPolicies(
        apiKey,
        tenantId,
        page,
        pageSize,
        search
      );

      setPolicies(response.content || []);
      setTotalCount(response.totalElements || 0);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [
    apiKey,
    tenantId,
    page,
    pageSize,
    search
  ]);

  useEffect(() => {
    fetchPolicies();
  }, [fetchPolicies]);

  return {
    policies,
    totalCount,
    loading,
    error,
    refresh: fetchPolicies
  };
}